import React from 'react'
import { Form } from 'react-final-form'

import FormContact from './FormContact'

import usePostMessageAdmin from '@/lib/hook/usePostMessageAdmin'
import { makeRequired, makeValidate } from '@/lib/makeValidate'
import schema from './schema'
import logger from '@/lib/logger'
import FONTS from '@/src/fonts'
import { toast } from 'react-toastify'

const validate = makeValidate(schema)
const requiredtab = makeRequired(schema)

type Props = {
  title?: string
  forceColor?: string
}

const ContactHome: React.FC<Props> = ({
  title = t({ id: 'web_bienvenue_sur_notre_plateforme' }),
  forceColor = 'black',
}) => {
  const { postMessage } = usePostMessageAdmin()

  const onSubmit = async values =>
    postMessage(
      `Demande de contact`,
      `Nom : ${values.title} ${values.name} - Pharmacie : ${values.pharmacie_name} - Téléphone : ${values.phone}`
    )
      .then(() => toast.success(t({ id: 'web_successfully_send_message' })))

      .catch(logger.error)

  return (
    <div style={{ color: `${forceColor}` }}>
      <div style={{ fontSize: 18, fontWeight: FONTS.WEIGHT.BOLD, textAlign: 'center' }}>
        {title}
      </div>

      <Form
        onSubmit={onSubmit}
        validate={validate}
        render={rest => <FormContact {...rest} requiredtab={requiredtab} forceColor={forceColor} />}
      />
    </div>
  )
}

export default ContactHome
